import useLmmStore from '../useLmmStore';

export const useLmmTijdstippen = () => useLmmStore((state) => state.lmmTijdstippen);
export const useLmmOpenTijdstip = () => useLmmStore((state) => state.lmmOpenTijdstip);
export const useLmmOpenBenodigdOpbouw = () => useLmmStore((state) => state.lmmOpenBenodigdOpbouw);
export const useLmmSortField = () => useLmmStore((state) => state.lmmSortField);
export const useLmmSortDirection = () => useLmmStore((state) => state.lmmSortDirection);

export const useSetLmmTijdstippen = () => useLmmStore((state) => state.setLmmTijdstippen);
export const useSetLmmOpenTijdstip = () => useLmmStore((state) => state.setLmmOpenTijdstip);
export const useToggleLmmOpenBenodigdOpbouw = () => useLmmStore((state) => state.toggleLmmOpenBenodigdOpbouw);
export const useSetLmmSort = () => useLmmStore((state) => state.setLmmSort);
